var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHome(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 23,
    viewBox: "0 0 22 23",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M7.907 22.349c.312 0 .567-.239.567-.53v-5.925c0-.291.256-.53.568-.53h3.916c.312 0 .568.239.568.53v5.952c0 .29.255.529.567.529h4.57c1.56 0 2.837-1.19 2.837-2.645V9.597c0-.582-.255-1.137-.71-1.56L12.335.998c-.738-.661-1.93-.661-2.64-.026L1.21 8.036A2.09 2.09 0 0 0 .5 9.597v10.106c0 1.455 1.277 2.646 2.838 2.646zm-6.272-2.646V9.597c0-.29.142-.582.34-.793l8.486-7.064c.284-.264.766-.264 1.078.027l8.457 7.037c.227.211.369.502.369.793v10.106c0 .873-.766 1.587-1.703 1.587h-4.001v-5.396c0-.873-.766-1.588-1.703-1.588H9.042c-.937 0-1.703.715-1.703 1.588v5.423H3.338c-.937-.027-1.703-.74-1.703-1.614z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.160f3b7c.svg";
export { ForwardRef as ReactComponent };